export default __webpack_public_path__ + "static/media/Spun-Drier.e7ea205a.jpg";